import * as React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import {Nav, ChatWidget} from '../global/components/index';
import {Home} from '../pages/home';
import {SendNotification} from "../pages/tools/send_notification/components";
import {CompleteOrderShipment} from "../pages/tools/complete_order_shipment/components";
import {PharmacyCustomer} from "../pages/tools/pharmacy_customer/components";
import {UpdatePharmacyCustomerPage} from "../pages/tools/update_pharmacy_customer/components";
import {SearchCustomer} from "../pages/tools/search_pharmacy_customer/components";
import {AdminSection} from "../pages/tools/admin/components";
import {AddDrugSection} from "../pages/tools/admin/components/drug/components";
import {PrescriptionLifecycleSection} from "../pages/tools/prescription_lifecycle";
import {PacManPage} from "../pages/tools/pacman";
import {ThirdPartyCustomer} from "../pages/tools/third_party_customer";
import {CreateHubsPatientSection, GetHubsPatientSection, HubsPage, GetHubsPrescriptionSection, GetHubsOrderSection,
    CancelHubsOrderSection, CreateHubsOrderSection, CreateHubsPrescriptionSection, CreateHubsPaymentInstrumentSection}
    from "../pages/tools/hubs/components";
import {CachedPharmacyCustomerProviderPage, CpcpV2Page, CustomerJourneyPage, RecipeViewer} from "../pages/tools/cached_pharmacy_customer_provider";
import {NonMobileEnrollmentCustomerProviderPage} from "../pages/tools/non_mobile_enrollment";
import {SignIn} from "../pages/signin";
import {ErrorPage} from "../pages/error";
import { PrescriptionIngestion } from '../pages/tools/prescription_ingestion';
import { ShipmentOperationsPage } from '../pages/tools/shipment_operations';
import { ConsumptionGuardOverridePage } from '../pages/tools/consumption_guard_override';
import { CopayWaiverPage } from '../pages/tools/copay_waiver';
import { ClaimsPage } from '../pages/tools/claims';

class App extends React.Component<{}, {}> {

  private contentRef = React.createRef<HTMLDivElement>();

  constructor(props: {}) {
    super(props);
    this.handleChatLayoutChange = this.handleChatLayoutChange.bind(this);
  }

  handleChatLayoutChange(width: number, isResizing: boolean) {
    if (this.contentRef.current) {
      this.contentRef.current.style.transition = isResizing
        ? 'none'
        : 'margin-right 0.2s ease';
      this.contentRef.current.style.marginRight = `${width}px`;
    }
  }

  public render() {
    return (
        <BrowserRouter>
            <div ref={this.contentRef}>
              <Nav/>
              <Route exact path='/' component={Home}/>
              <Route path='/sign-in' component={SignIn}/>
              <Route path='/error' component={ErrorPage}/>
              <Route path='/create-pharmacy-customer/' component={PharmacyCustomer}/>
              <Route path='/update-pharmacy-customer/' component={UpdatePharmacyCustomerPage}/>
              <Route path='/send-notifications/' component={SendNotification}/>
              <Route path='/third-party-customer/' component={ThirdPartyCustomer}/>
              <Route path='/complete-order-shipment/' component={CompleteOrderShipment}/>
              <Route path='/search-pharmacy-customer/' component={SearchCustomer}/>
              <Route path='/admin' component={AdminSection}/>
              <Route path='/add-drug' component={AddDrugSection}/>
              <Route path='/manage-prescriptions' component={PrescriptionLifecycleSection}/>
              <Route path='/pacman' component={PacManPage}/>
              <Route path='/hubs' component={HubsPage}/>
              <Route path='/cached-pharmacy-customer-provider' component={CachedPharmacyCustomerProviderPage}/>
              <Route path='/customer-journey' component={CustomerJourneyPage}/>
              <Route path='/cpcp-v2' component={CpcpV2Page}/>
              <Route path='/cpcp-v2-recipe' component={RecipeViewer}/>
              <Route path='/non-mobile-enrollment-customer-provider' component={NonMobileEnrollmentCustomerProviderPage}/>
              <Route path='/tools/hubs/create-patient' component={CreateHubsPatientSection}/>
              <Route path='/tools/hubs/get-patient' component={GetHubsPatientSection}/>
              <Route path='/tools/hubs/get-prescription' component={GetHubsPrescriptionSection}/>
              <Route path='/tools/hubs/get-order' component={GetHubsOrderSection}/>
              <Route path='/tools/hubs/cancel-order' component={CancelHubsOrderSection}/>
              <Route path='/tools/hubs/create-order' component={CreateHubsOrderSection}/>
              <Route path='/tools/hubs/create-prescription' component={CreateHubsPrescriptionSection}/>
              <Route path='/tools/hubs/create-payment-instrument' component={CreateHubsPaymentInstrumentSection}/>
              <Route path="/prescription-ingestion" component={PrescriptionIngestion}/>
              <Route path="/shipment-operations" component={ShipmentOperationsPage} />
              <Route path="/consumption-guard-override" component={ConsumptionGuardOverridePage} />
              <Route path="/copay-waiver" component={CopayWaiverPage} />
              <Route path="/claims" component={ClaimsPage} />
            </div>
            <ChatWidget onLayoutChange={this.handleChatLayoutChange} />
        </BrowserRouter>
    );
  }
}

export default App;
